@import 'abstract/mixins';
@import 'abstract/colors';

product-checkout-submitter {
  width: 100%;

  form {
    .product-cta-tabs {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @include breakpoint(sm) {
        position: relative;
        width: calc(100% + 30px);
        left: -15px;
      }

      .tab {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        text-align: center;
        width: 50%;
        color: $dim-gray;
        border-bottom: 2px solid $very-light-gray-2;

        .arrow {
          position: absolute;
          border-top: 8px solid $very-light-gray-2;
          border-left: 8.5px solid transparent;
          border-right: 8.5px solid transparent;
          bottom: -10px;
        }

        &.active {
          color: $main-blue;
          border-bottom: 2px solid $blue;

          .arrow {
            border-top: 8px solid $blue;
          }
        }

        &.disabled {
          cursor: default;
        }

        h2 {
          padding-bottom: 12px;
          text-align: center;
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          margin: 0;
        }
      }
    }

    .benefits {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;

      @include breakpoint(sm) {
        justify-content: start;
      }

      .benefit {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        @include breakpoint(sm) {
          justify-content: start;
          width: 50%;
        }

        img {
          margin-right: 8px;
        }

        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: $dark-blue;
        }
      }
    }

    .gift {
      color: $dark-blue;
      display: flex;
      align-items: center;
      margin-top: 16px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;

      @include breakpoint(sm) {
        justify-content: start;
      }

      img {
        margin-right: 8px;
      }
    }

    .btn-subscribe {
      border-radius: 50px;
      height: 48px;
      font-weight: 500;
      font-size: 16px;
      margin-top: 12px;
      width: 100%;
      box-shadow: var(--button-box-shadow);

      @include breakpoint(sm) {
        margin-bottom: 9px;
      }

      i {
        position: absolute;
        right: 15px;
        font-size: 22px;
      }

      &-disabled {
        cursor: not-allowed !important;
        opacity: 0.7;
      }
    }

    .delivery {
      color: $dark-blue;
      display: flex;
      align-items: center;
      margin-top: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;

      @include breakpoint(sm) {
        justify-content: start;
        margin-top: 16px;
      }

      img {
        margin-right: 8px;
      }

      .date {
        color: $blue;
      }
    }

    .subscription-tou {
      text-align: center;
      font-size: 12px;
      line-height: 16px;
      margin-top: 16px;
      @include breakpoint(sm) {
        margin-bottom: -4px;
      }

      a {
        color: $main-blue;
        cursor: pointer;

        @include breakpoint(sm) {
         display: block;
        }
      }
    }

    .advantages {
      display: inline-block;
      text-align: left;

      &-container {
        text-align: center;
      }
    }
  }
}
